import styles from "./styles.module.css";
import TasksTable from "@/components/organisms/TasksTable";
import { useTranslation } from "react-i18next";
import { Box } from "@mantine/core";
import { DEFAULT_TASK_COLUMNS } from "@/components/organisms/InvoiceTable/const/default";
import Heading from "@/components/atoms/Heading";

export default function Tasks() {
  const { t } = useTranslation();

  return (
    <>
      <title>{`Reviver - ${t("common:tasks")}`}</title>
      <meta name="description" content={`Reviver - ${t("common:tasks")}`} />
      <Box className={styles.tasksRoot}>
        <Heading order={1} styleOrder={4} strong mb={24} mt={32}>
          {t("tasks:myTasks")}
        </Heading>
        <TasksTable visibleColumns={DEFAULT_TASK_COLUMNS} initialSort={[]} initialRowsPerPage={15} />
      </Box>
    </>
  );
}
